import React from "react";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { truncateWords } from "../../components/truncateWords";
function LowStock() {
  const { fetchOnlyData } = SupervisorApi();

  const { data } = useQuery({
    queryKey: ["lowstock"],
    queryFn: () => fetchOnlyData("dashboard/low-stock-products"),
    retry: 1,
    keepPreviousData: true,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return (
    <div className="w-3/12 bg-white shadow-md py-4 pb-24 px-2 h-screen overflow-y-auto">
      <h3 className="text-2xl font-semibold mb-2">Low Stock</h3>
      <div className="border rounded-md ">
        <div className="flex justify-between items-center p-2 bg-gray-600 text-white">
          <h3 className="text-lg font-medium">Products</h3>
          {/* <h4 className="text-base ">Stock</h4> */}
        </div>

        <ul className="space-y-4 px-2 py-2">
          {data?.map((item) => (
            <li key={item?.id} className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <ImageWithPlaceholder
                  item={item}
                  className="w-8 rounded-md"
                  placeholderClassName="text-[20px] bg-gray-200 px-2 py-1 font-bold text-base rounded-md"
                />

                <span>{truncateWords(item?.product_name, 20)}</span>
              </div>
              <span className="text-red-500 font-bold">
                {item?.available_quantity}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LowStock;
